import { combineReducers } from '@reduxjs/toolkit'

import adminEvaluationReducer from './admin-evaluation'
import adminArtifactReducer from './admin-artifact'
import adminGoalReducer from './admin-goal'
import adminSelfEvaluationReducer from './admin-eval-rating'
import adminEvaluationDetailsReducer from './admin-eval-self'

const combinedReducer = combineReducers({
  evaluation: adminEvaluationReducer,
  artifact: adminArtifactReducer,
  goal: adminGoalReducer,
  selfEvaluation: adminSelfEvaluationReducer,
  evaluationDetails: adminEvaluationDetailsReducer
})

export default combinedReducer
